import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const TESTIMONIALS = [
  {
    quote:
      "RAZMEK reestructuró nuestra protección patrimonial con una claridad que ningún banco privado había logrado. Hoy entiendo cada peso que cubre mi familia.",
    name: "Adriana M.",
    role: "Empresaria · 12 años de relación",
  },
  {
    quote:
      "Lo que más valoro es la consistencia. Cada año revisan mi estrategia y ajustan con la misma seriedad con la que la diseñaron desde el primer día.",
    name: "Eduardo G.",
    role: "Director financiero · 8 años de relación",
  },
  {
    quote:
      "Pasamos de tener 4 pólizas dispersas a una arquitectura coherente. La diferencia en prima fue menor; la diferencia en tranquilidad, abismal.",
    name: "Familia Hernández",
    role: "Clientes patrimoniales · 6 años de relación",
  },
];

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const current = TESTIMONIALS[idx];

  return (
    <section className="py-24 lg:py-32 bg-razmek-alt">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="eyebrow">Testimonios</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-razmek-dark">
            Confianza que se mide
            <br />
            <span className="italic text-razmek-blue">en décadas</span>.
          </h2>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -14 }}
            transition={{ duration: 0.45 }}
            className="text-center"
          >
            <span className="font-serif text-7xl text-razmek-gold leading-none">“</span>
            <p className="font-serif text-2xl md:text-3xl lg:text-4xl leading-[1.3] text-razmek-dark max-w-3xl mx-auto italic">
              {current.quote}
            </p>
            <div className="mt-10">
              <div className="font-sans text-base text-razmek-dark">
                {current.name}
              </div>
              <div className="mt-1 eyebrow text-razmek-gray">{current.role}</div>
            </div>
          </motion.div>
        </AnimatePresence>

        <div className="mt-12 flex items-center justify-center gap-4">
          {TESTIMONIALS.map((t, i) => (
            <button
              key={t.name}
              onClick={() => setIdx(i)}
              data-testid={`testimonial-dot-${i}`}
              aria-label={`Testimonio ${i + 1}`}
              className={`transition-all ${
                i === idx
                  ? "w-10 h-[2px] bg-razmek-gold"
                  : "w-6 h-[2px] bg-razmek-gray/40 hover:bg-razmek-gray"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
